import * as React from 'react';
import * as styles from './pagination.module.scss';
import PaginatedQueryFunction from './paginated-query-function';

/**
 * @interface
 * @param {number} count - The number of results per page this component represents.
 * @param {number} currentPageSize - The currently selected number of results per page.
 * @param {string} searchTerm - Search term for the fetch query.
 * @param {PaginatedQueryFunction} fetchResults - Function to query for a page of results.
 * @param {Object} fetchExtraProps - Optional object with extra properties to include in the fetchResults function call.
 */
interface Props {
  count: number;
  currentPageSize: number;
  searchTerm: string;
  orderColumn: string;
  orderDirection: 'asc' | 'desc' | null;
  fetchResults: PaginatedQueryFunction;
  fetchExtraProps?: Object;
}

/**
 * @function PageCount - Component displaying an option for page size on table components
 * @param {Props} props - Props to fetch the appropriate page of results
 */
const PageCount = ({
  count,
  currentPageSize,
  searchTerm,
  orderColumn,
  orderDirection,
  fetchResults,
  fetchExtraProps
}: Props) => {
  return (
    <span
      onClick={() =>
        fetchResults({
          currentPage: 1,
          pageSize: count,
          searchTerm,
          orderColumn,
          orderDirection,
          ...fetchExtraProps
        })
      }
      className={`${styles.pageAmount} ${currentPageSize === count ? styles.pageAmountActive : ''}`}
    >
      {count}
    </span>
  );
};

export default PageCount;
